import { Box } from '@mui/material';

const ActionPlaceholder = () => <Box mr={1} width="24px" height="24px" />;

export default ActionPlaceholder;
